export enum CartState {
  cartQuote = "cartQuote",
  cartUpdate = "cartUpdate",
  cartFulfill = "cartFulfill",
}
